import * as Sentry from '@sentry/react';
import { store } from 'app/redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import { StrictMode } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';
import { sentryConfig } from 'sentry-config';
import { App } from './app/App';
import './index.css';
import reportWebVitals from './reportWebVitals';

Sentry.init(sentryConfig);

ReactDOM.render(
  <StrictMode>
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
